import { useRoutes } from 'react-router-dom'
import routes from './router'
import './scss/style.scss'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const App = () => {
  const routing = useRoutes(routes)
  return <div>
    
    {routing}
  <ToastContainer/>
  </div>
}

export default App
